import React, { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

const Button = ({ children, onClick, svg = null, disable, className = "" }) => {
  const buttonRef = useRef(null);
  const circleRef = useRef(null);

  useGSAP(() => {
    const button = buttonRef.current;
    if (!button || disable) return;

    // Magnetic Effect (Subtle)
    const xTo = gsap.quickTo(button, "x", { duration: 0.4, ease: "power3.out" });
    const yTo = gsap.quickTo(button, "y", { duration: 0.4, ease: "power3.out" });

    const handleMouseMove = (e) => {
      const { clientX, clientY } = e;
      const { left, top, width, height } = button.getBoundingClientRect();
      const x = clientX - (left + width / 2);
      const y = clientY - (top + height / 2);
      xTo(x * 0.1);
      yTo(y * 0.1);
    };

    const handleMouseLeave = () => {
      xTo(0);
      yTo(0);
    };

    button.addEventListener("mousemove", handleMouseMove);
    button.addEventListener("mouseleave", handleMouseLeave);

    // Hover Animation (Circle Expand)
    const tl = gsap.timeline({ paused: true });
    tl.to(circleRef.current, { width: "200%", paddingBottom: "200%", duration: 0.4, ease: "power2.inOut" });

    button.addEventListener("mouseenter", () => tl.play());
    button.addEventListener("mouseleave", () => tl.reverse());

    return () => {
      button.removeEventListener("mousemove", handleMouseMove);
      button.removeEventListener("mouseleave", handleMouseLeave);
      button.removeEventListener("mouseenter", () => tl.play());
      button.removeEventListener("mouseleave", () => tl.reverse());
    };
  }, []);

  return (
    <button
      ref={buttonRef}
      onClick={onClick}
      disabled={disable}
      className={`relative overflow-hidden rounded-full bg-designColor px-6 py-2.5 font-primary text-base font-semibold text-white shadow-lg transition-all duration-300 hover:bg-opacity-90 hover:-translate-y-0.5 hover:shadow-glow disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
    >
      <span className="relative z-10 flex items-center justify-center gap-2 pointer-events-none">
        {svg && svg}
        {children}
      </span>
      {/* Animated Circle Background - simplified or kept if compatible */}
      <div 
        ref={circleRef}
        className="absolute left-1/2 top-1/2 w-0 pb-0 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white bg-opacity-20 z-0 pointer-events-none"
      />
    </button>
  );
};

export default Button;
